import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
    headingStyle: {
        fontFamily: "MAN-light, Arial, sans-serif",
        fontSize: theme.typography.pxToRem(22),
        fontWeight: "300",
        color: "#303a44",
        lineHeight: 1.11,
    },
});

const Heading4 = ({ classes: { headingStyle }, className, component, children, ...otherProps }) => {
    const headingClass = classNames(headingStyle, className);
    return (
        <Typography component={component || "h4"} className={headingClass} {...otherProps}>
            {children}
        </Typography>
    );
};

Heading4.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    children: PropTypes.node,
};

export default withStyles(styles)(Heading4);



// WEBPACK FOOTER //
// ./src/styleguide/Heading4.js